import { rootApi } from "../../api/rootApi";

export const pgCredentials = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchPGCredentials: builder.query({
        query: (params) => {
          return {
            method: "GET",
            url: `/tenant/pgCredentials`,
            // url: `/tenant/giftCatalogue/?limit=${params.limit}&&offset=${params.offset}`,
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + params.token,
              slug: params.tenant_id,
            },
          };
        },
      }),
    addPGCredentials: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/pgCredentials/add`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    deletePGCredentials: builder.mutation({
      query: (params) => {
        return {
          method: "DELETE",
          url: `/tenant/pgCredentials/${params.id}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),
  }),
});

export const {
 useAddPGCredentialsMutation,
 useDeletePGCredentialsMutation,
 useFetchPGCredentialsQuery
} = pgCredentials;
